import { httpPost } from "../http"

export interface GetConfigCancelReasonsResponse {
  code: number
  reasons: Reason[]
  warning_message: string
  warning_icon_url: string
  popup_button_text_color: string
}

export interface Reason {
  group: string
  message: string
  reach_threshold: boolean
  popup_message: string
  reason: string
  popup_title: string
  popup_button_text: string
}

export function v1GetConfigCancelReasons(body: { sessionId: string }) {
  return httpPost<GetConfigCancelReasonsResponse>(
    "be-configuration/customer/get_config_cancel_reasons",
    {
      session_id: +body.sessionId,
    }
  )
}

export function v1GetConfigInternationalPhoneNo(body: {
  login_type: string
  locale: string
}) {
  return httpPost(
    "be-configuration/public/get_config_international_phone_no",
    body
  )
}

export interface GetHomeDiscoverySessionResponse {
  code: number
  msg: string
  items: DiscoverySessionItem[]
  message: string
}

export interface DiscoverySessionItem {
  ad_id: string
  zone_id: string
  campaign_id: string
  campaign_name: string
  description: string
  order: number
  is_default: boolean
  title: Title
  sub_title: Title
  image_link: Title
  tag: Title
  deep_link: string
  schedule_type: string
  status: number
  updated_by: string
}

interface Title {
  en: string
  vi: string
}

export function v1GetHomeDiscoverySession() {
  return httpPost<GetHomeDiscoverySessionResponse>(
    "be-configuration/customer/get_home_discovery_session",
    {}
  )
}

export interface HomeScreenRecommendedAddress {
  recommend_addresses: Recommendaddress[]
  addresses: Recommendaddress[]
}

interface Recommendaddress {
  id: number
  addr: string
  type: string
  lat: number
  lng: number
  children: any[]
}

export function v1GetHomeRecommendedAddress() {
  return httpPost<HomeScreenRecommendedAddress>(
    "be-trip/customer/get_home_screen_recommend_address",
    {}
  )
}
